// @ts-nocheck
import { useContext } from 'react';
import { ConfigContext } from '@/context';
import { ComplianceRequestCreate } from './ComplianceRequestCreate';

export function ComplianceRequestDoNotSell(props) {
  const {
    doNotSellRequestName,
    doNotSellRequestDescription,
    privacyRequestsRequestsText,
  } = useContext(ConfigContext);

  return (
    <ComplianceRequestCreate
      description={doNotSellRequestDescription}
      placeholder={privacyRequestsRequestsText}
      requestType="do_not_sell"
      title={doNotSellRequestName}
      {...props}
    />
  );
}
